export default __webpack_public_path__ + "static/article-renovation-value-add-3635908a41fb9a1f5f9c376f67326b4a.jpg";